import { SummerBreakBanner } from '@/components/summer-break-banner'
import Routing from '@/routing'

import '@/styles/main.css'

export default function App() {
	return (
		<>
			<SummerBreakBanner />
			<Routing />
		</>
	)
}
